import { cva } from 'class-variance-authority';

export const avatarVariants = cva('ui-avatar', {
  variants: {
    size: {
      '2xs': 'ui-avatar--2xs',
      xs: 'ui-avatar--xs',
      sm: 'ui-avatar--sm',
      md: 'ui-avatar--md',
      lg: 'ui-avatar--lg',
      xl: 'ui-avatar--xl',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});
